import React from 'react';
import './Layout.css';
import icon from './images/icon1.png';
import { Player } from 'video-react';
import "../../../node_modules/video-react/dist/video-react.css"; // import css



function Grid(props){
    return(
        <div className="video-grid"> 
            <Player fluid={false} width={240} height={130} src={props.url}/> 
            <h6 className="book-time">{props.time}</h6>
             <section className="row">
                 <div className="column user-logo"><img src={icon}/></div>
                 <div className="column">
                    <h1 className="video-title">{props.title}</h1>
                     <p className='video-author'>{props.author}</p>
                 </div> 
             </section>
            <section className="button-area">
            <button className="button-rvsp">RVSP</button>
            <button className="button-details">Details</button>
            </section>
        </div>
        
    )
}

export default Grid;